import { render, staticRenderFns } from "./PhaseTypeChoose.vue?vue&type=template&id=bca79112&scoped=true"
import script from "./PhaseTypeChoose.vue?vue&type=script&lang=js"
export * from "./PhaseTypeChoose.vue?vue&type=script&lang=js"
import style0 from "./PhaseTypeChoose.vue?vue&type=style&index=0&id=bca79112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca79112",
  null
  
)

export default component.exports